export const LANGUAGE_STORAGE_KEY = 'app_language';

/**
 * Resolve saved language. Prefer explicit app key, then keys used by i18n sync.
 * Default: English (matches site default when nothing is stored).
 */
export const getLanguageFromStorage = (): string => {
  try {
    const fromApp = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    const fromShared = localStorage.getItem('shared_app_language');
    const fromLegacy = localStorage.getItem('selectedLanguage');
    const storedLanguage = fromApp || fromShared || fromLegacy;
    return storedLanguage || 'en';
  } catch (error) {
    console.warn('Failed to get language from localStorage:', error);
    return 'en';
  }
};

export const setLanguageInStorage = (language: string): void => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    console.warn('Failed to save language to localStorage:', error);
  }
}; 